module.exports = __webpack_public_path__ + "img/prepayment_required_icon.f6f0df6d.svg";